import {useRouteMatch, Switch, Route} from 'react-router-dom';
import {UserInfo} from './user-info';
import React, {FC} from 'react';

export const UserInfoRoute: FC = React.memo(() => {
  let match = useRouteMatch();

  return (
    <Switch>
      <Route path={match.path}>
        <UserInfo />
      </Route>
    </Switch>
  );
});
